import FloatingVideo from "./FloatingVideo.svelte";

const app = new FloatingVideo({
  target: document.body,
});

export default app;
